export function isAgentQuery(query, agentName) {
    const resolver = query.resolver;
    if ('agentName' in resolver) {
        return resolver.agentName === agentName;
    }
    return false;
}
